import { Route, Routes } from "react-router-dom";
//import N1Issuers from "./N1Issuers/main";
import N1Events from "./N1Events/main";
import N1Portfolios from "./N1Portfolios/main";
import N1StaticData from "./N1StaticData/main";
import N1TimeSeries from "./N1TimeSeries/main";
import N1Transactions from "./N1Transactions/main";
import N1Plans from "./N1Plans/main";
import N1DataUpload from "./N1DataUpload/main";
import N1BankPositions from "./N1BankPositions/main";

import { Tables } from "../../gen/tableNames/tables";
import { ClientTables } from "@/lib/clientTables";

export default function N1Routes() {
  return (
    <Routes>
      {/*<Route path="n1_issuers/*" element={<N1Issuers />} />*/}
      <Route path={`${Tables.N1_EVENTS}/*`} element={<N1Events />} />
      <Route path={`${Tables.N1_PORTFOLIOS}/*`} element={<N1Portfolios />} />
      <Route path={`${Tables.N1_STATIC_DATA}/*`} element={<N1StaticData />} />
      <Route path={`${Tables.N1_TIME_SERIES}/*`} element={<N1TimeSeries />} />
      <Route
        path={`${Tables.N1_TRANSACTIONS}/*`}
        element={<N1Transactions />}
      />
      <Route path={`${Tables.N1_BANK_POSITIONS}/*`} element={<N1BankPositions />} />
      <Route path={`${Tables.N1_PLANS}/*`} element={<N1Plans />} />
      <Route
        path={`${ClientTables.N1_DATA_UPLOAD}/*`}
        element={<N1DataUpload />}
      />
    </Routes>
  );
}
